<template>
  <transition name="modal-fade">
    <div class="modal-backdrop-new">
      <div
        class="modal-new"
        role="dialog"
        aria-labelledby="modalTitle"
        aria-describedby="modalDescription"
      >
        <header class="modal-header-new" id="modalTitle">
          <slot name="header">Error: {{errorTitle}}</slot>
          <button type="button" class="btn-close" @click="close" aria-label="Close modal">x</button>
        </header>
        <section class="modal-body-new" id="modalDescription">
          <slot name="body">
            <div>
              <label class="mb-3" style="width: 400px; padding-left:20px">{{errorMessage}}</label>
              
             
            </div>
             <a
                class="alpha-btn"
                style="color: white; cursor: pointer;width: 160px; text-align: center"
                @click="cancelModal"
              >Close</a>
              <a
                class="alpha-btn"
                style="color: white; cursor: pointer;width: 160px; text-align: center;margin-top: -39px;margin-left: 235px;"
                @click="allowAction"
              >Continue</a>
          </slot>
        </section>
      </div>
    </div>
  </transition>
</template>



<script>
import { isTokenValid } from "../../utils/util";
import * as XLSX from 'xlsx';

export default {
  name: "confirmationModal",
  props: ["errorTitle","errorMessage", "cancelModal", "allowAction"],
  data() {
    return {
    };
  },

  methods: {
    close() {
      this.cancelModal();
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Dialogs/confirmationModal.vue